package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.outlined.ChatBubbleOutline
import androidx.compose.material.icons.outlined.LocalFireDepartment
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.model.ActivityUserContext
import com.sweetlime.bingeamigo.model.UserActivity
import com.sweetlime.bingeamigo.model.types.ActivityType
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource

@Composable
fun FriendActivityCard(
    activity: UserActivity,
    userContext: ActivityUserContext?,
    reacted: Boolean,
    reactionCount: Int,
    commentCount: Int,
    onClick: (UserActivity) -> Unit,
    onReact: (UserActivity) -> Unit,
    onComment: (UserActivity) -> Unit,
    onAddToList: (UserActivity) -> Unit,
    modifier: Modifier = Modifier,
    groupedCount: Int = 1,
    rangeLabel: String? = null,
) {
    val isTv = activity.tvShowId != 0
    val title = if (isTv) activity.tvShowTitle else activity.movieTitle
    val posterPath = if (isTv) activity.tvShowPoster else activity.moviePoster
    val posterUrl = "https://image.tmdb.org/t/p/w185$posterPath"
    val type = ActivityType.fromValue(activity.type)
    val hint = userContext?.let { computeActivityHint(activity, it) }

    val label = if (groupedCount > 1)
        "Watched $groupedCount episodes" else activityLabel(activity.type, activity.seasonNumber, activity.episodeNumber, activity.rating)

    Column(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .clip(RoundedCornerShape(18.dp))
            .background(BrandColors.Card)
            .border(1.dp, Color(0xFF2A2A2E), RoundedCornerShape(18.dp))
            .clickable { onClick(activity) }
            .padding(13.dp),
    ) {
        Row(verticalAlignment = Alignment.Top) {
            FriendAvatar(username = activity.username, photoUrl = activity.userAvatar.ifBlank { null }, type = type, size = 42.dp)
            Spacer(Modifier.width(12.dp))
            Column(Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(activity.username, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 14.5.sp, maxLines = 1, overflow = TextOverflow.Ellipsis, modifier = Modifier.weight(1f, fill = false))
                    Spacer(Modifier.weight(1f))
                    Text(relativeTime(activity.timestamp), color = Color(0xFF66666C), fontSize = 12.sp)
                }
                Spacer(Modifier.height(2.dp))
                Row {
                    Text(label, color = activityLabelColor(activity.type), fontWeight = FontWeight.Bold, fontSize = 12.5.sp)
                    if (groupedCount > 1 && rangeLabel != null) {
                        Text("  ·  $rangeLabel", color = BrandColors.TextSecondary, fontSize = 12.5.sp, fontWeight = FontWeight.SemiBold)
                    }
                }
                Spacer(Modifier.height(1.dp))
                Text(title, color = Color.White, fontWeight = FontWeight.SemiBold, fontSize = 14.sp, maxLines = 1, overflow = TextOverflow.Ellipsis)
                if (hint != null) {
                    Spacer(Modifier.height(7.dp))
                    Surface(color = hint.tone.bgColor(), shape = RoundedCornerShape(6.dp)) {
                        Text(hint.text, color = hint.tone.fgColor(), fontWeight = FontWeight.Bold, fontSize = 11.5.sp, maxLines = 1, modifier = Modifier.padding(horizontal = 8.dp, vertical = 3.dp))
                    }
                }
            }
            Spacer(Modifier.width(10.dp))
            KamelImage(
                resource = asyncPainterResource(posterUrl),
                contentDescription = title,
                contentScale = ContentScale.Crop,
                modifier = Modifier.size(width = 44.dp, height = 64.dp).clip(RoundedCornerShape(8.dp)).background(Color(0xFF222222)),
            )
        }

//        Spacer(Modifier.height(11.dp))
//        HorizontalDivider(color = Color(0xFF2A2A2E))
//        Spacer(Modifier.height(11.dp))
//        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
//            FeedChip(
//                icon = { Icon(Icons.Outlined.LocalFireDepartment, null, modifier = Modifier.size(14.dp)) },
//                label = if (reactionCount > 0) reactionCount.toString() else "React",
//                active = reacted,
//                onClick = { onReact(activity) },
//            )
//            FeedChip(
//                icon = { Icon(Icons.Outlined.ChatBubbleOutline, null, modifier = Modifier.size(14.dp)) },
//                label = if (commentCount > 0) commentCount.toString() else "Reply",
//                active = false,
//                onClick = { onComment(activity) },
//            )
//            Spacer(Modifier.weight(1f))
//            Surface(onClick = { onAddToList(activity) }, shape = RoundedCornerShape(9.dp), color = BrandColors.Secondary.copy(alpha = 0.13f)) {
//                Row(Modifier.padding(horizontal = 11.dp, vertical = 6.dp), verticalAlignment = Alignment.CenterVertically) {
//                    Icon(Icons.Filled.Add, null, tint = Color(0xFF2FD0D0), modifier = Modifier.size(13.dp))
//                    Spacer(Modifier.width(5.dp))
//                    Text("List", color = Color(0xFF2FD0D0), fontWeight = FontWeight.Bold, fontSize = 12.5.sp)
//                }
//            }
//        }
    }
}

@Composable
private fun FeedChip(icon: @Composable () -> Unit, label: String, active: Boolean, onClick: () -> Unit) {
    Surface(
        onClick = onClick,
        shape = RoundedCornerShape(9.dp),
        color = if (active) BrandColors.Primary.copy(alpha = 0.14f) else Color.Transparent,
        border = androidx.compose.foundation.BorderStroke(1.dp, Color(0xFF2A2A2E)),
    ) {
        Row(Modifier.padding(horizontal = 11.dp, vertical = 6.dp), verticalAlignment = Alignment.CenterVertically) {
            androidx.compose.runtime.CompositionLocalProvider(
                androidx.compose.material3.LocalContentColor provides if (active) BrandColors.Primary else BrandColors.TextSecondary
            ) { icon() }
            Spacer(Modifier.width(6.dp))
            Text(label, color = if (active) BrandColors.Primary else BrandColors.TextSecondary, fontWeight = FontWeight.Bold, fontSize = 12.5.sp)
        }
    }
}

private fun HintTone.fgColor(): Color = when (this) {
    HintTone.GREEN -> Color(0xFF5FE3B4)
    HintTone.YELLOW -> Color(0xFFFFCE4D)
    HintTone.RED -> Color(0xFFFF8E8E)
}
